import React from "react";
import { EditOutlined } from "@ant-design/icons";
import i18n from "i18next";
import { numberWithCommas } from "util/common";
import PlanOrgQuota from "./PlanOrgQuota";
import PlanProgressBar from "./PlanProgressBar";
import { resolveRemainingAiCredits } from "./planAiCreditsDisplay";
import { resolveDashboardQuota } from "util/planEntitlements";
import styles from "./style.module.scss";

const PlanCoreQuotas = ({
  plan,
  alertLimits,
  alertLimitsLoading,
  canManagePurchases,
  canUpdateAiCredits,
  onOpenAiCreditsModal,
  aiCreditsSaving,
  isEnterprise = false,
  onContactSales,
}) => {
  const remainingAi = resolveRemainingAiCredits(plan) ?? 0;
  const aiTotal = Number(plan?.AiCreditsTotal ?? 0);
  const aiUsed = Number(plan?.AiCreditsUsed ?? 0);
  const hasAiTotal = Number.isFinite(aiTotal) && aiTotal > 0;
  const dashboardQuota = resolveDashboardQuota(plan);

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{i18n.t("settings.plan_core_quotas_title")}</h3>

      {plan?.PackageId !== 68 ? (
        <PlanProgressBar
          label={i18n.t("settings.plan_dashboards_label")}
          used={dashboardQuota.used}
          max={dashboardQuota.limit}
          footer={
            dashboardQuota.remaining != null ? (
              <span className={styles.quotaProgressCaption}>
                {i18n.t("settings.plan_dashboard_remaining_hint", {
                  count: numberWithCommas(dashboardQuota.remaining),
                })}
              </span>
            ) : null
          }
        />
      ) : null}

      <PlanProgressBar
        label={i18n.t("settings.plan_ai_credits_usage_label")}
        used={hasAiTotal ? aiUsed : 0}
        max={hasAiTotal ? aiTotal : null}
        headerAction={
          canUpdateAiCredits ? (
            <button
              type="button"
              className={styles.quotaProgressEditBtn}
              onClick={onOpenAiCreditsModal}
              disabled={aiCreditsSaving}
              aria-label={i18n.t("settings.plan_ai_credits_edit")}
            >
              <EditOutlined />
              <span>{i18n.t("settings.plan_ai_credits_edit_short")}</span>
            </button>
          ) : null
        }
        footer={
          hasAiTotal ? (
            <span className={styles.quotaProgressCaption}>
              {i18n.t("settings.plan_ai_credits_remaining_hint", {
                count: numberWithCommas(remainingAi),
              })}
            </span>
          ) : null
        }
      />

      <PlanOrgQuota
        limits={alertLimits}
        loading={alertLimitsLoading}
        canPurchase={canManagePurchases}
        isEnterprise={isEnterprise}
        onContactSales={onContactSales}
      />
    </div>
  );
};

export default PlanCoreQuotas;
